import { ErrorHandler, Injectable, signal } from '@angular/core';

import { createErrorHandler } from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class ZefErrorHandler extends ErrorHandler {
  readonly error = signal<boolean>(false);

  readonly handler = createErrorHandler();

  handleError(error: Error) {
    this.error.set(true);

    this.handler.handleError(error);
  }
}
